import { IOrderBeingPrepared } from 'my-poppies-b2b-types';

import { timestampMockHelpers } from '@/utils/timestampMockHelpers';

export const dummyDataOrdersBeingPrepared: IOrderBeingPrepared[] = [
  {
    erpId: 'some-erp-id-2093921212',
    userRole: 'EVA',
    id: 'first-being-prepared-order',
    sender: 'SOME_SENDER',
    priority: 'HIGH',
    createdBy: 'BERNHARD',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'BERNHARD',
    updatedAt: timestampMockHelpers.now,
    customerId: 'customer-0',
    customerPretty: 'Customer Name Pretty',
    status: 'BEING_PREPARED',
    positions: [
      { positionId: 'kleine-kapseln-40g', amount: 123 },
      { positionId: 'große-kapseln-120g', amount: 14 },
    ],
  },
  {
    erpId: 'some-erp-id-12321333',
    userRole: 'EVA',
    id: 'second-being-prepared-order',
    sender: 'SOME_SENDER',
    priority: 'LOW',
    createdBy: 'EVA',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'BERNHARD',
    updatedAt: timestampMockHelpers.tenMinutesLater,
    customerId: 'customer-1',
    customerPretty: 'Customer Name Pretty',
    status: 'BEING_PREPARED',
    positions: [{ positionId: 'palette-800-100', amount: 17 }],
    history: [
      { shippingStatus: 'LABEL_CREATED', shippingStatusPretty: { de: 'Label erstellt', en: 'Label created' }, startedAt: 8923418, location: 'Innsbruck' },
    ],
  },
];
